import { toast } from '@/components/ui/use-toast';
import { Match } from '@/api';

export function useMatchOpeningDescription({
	matchId,
	timerSettings,
	setIsSettingTimer,
}: {
	matchId: any;
	timerSettings: any;
	setIsSettingTimer: (value: boolean) => void;
}) {
	const handleUpdateMatchOpeningDescription = async () => {
		if (!matchId) {
			toast({
				variant: 'destructive',
				title: 'Error',
				description: 'No match selected to update label.',
			});
			return;
		}

		if (!timerSettings) {
			toast({
				variant: 'destructive',
				title: 'Error',
				description: 'Please enter a valid market open text.',
			});
			return;
		}

		try {
			await Match.updateOpeningDescription({
				match_id: matchId,
				opening_description: timerSettings,
			});
			setIsSettingTimer(false);
			toast({
				title: 'Success',
				description: 'Match label updated successfully.',
			});
		} catch (err) {
			toast({
				variant: 'destructive',
				title: 'Error',
				description: 'Failed to update match label. Please try again.',
			});
			console.error(err);
			throw new Error('Failed to update match label:');
		}
	};

	return { handleUpdateMatchOpeningDescription };
}
